import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import classNames from 'classnames'
import _ from 'lodash'
import withLanguage from '../lang-select/withLanguage'

const ListingHeader = ({ params, language = 'th' }) => <Breadcrumb />

const Breadcrumb = withRouter(({ match }) => {
  return (
    <nav className="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li
          className={classNames({
            'is-active': !_.get(match, 'params.listingID'),
          })}
        >
          <Link to={`/towns/${match.params.townID}/listings`} replace>
            Listing List
          </Link>
        </li>

        {_.get(match, 'params.listingID') && (
          <li
            className={classNames({
              'is-active': true,
            })}
          >
            <Link to={`/listings`}>Listing Detail</Link>
          </li>
        )}
      </ul>
    </nav>
  )
})

export default withLanguage(ListingHeader)



// WEBPACK FOOTER //
// ./src/components/templates/navbar/ListingHeader.js